import {
  Card,
  CardContent,
  Typography,
  ButtonGroup,
  Select,
  MenuItem,
} from '@material-ui/core';
import NavigationButtons from 'components/navigationButtons';
import CloseIcon from 'components/SahamIcons/Close';
import { pushTo } from 'containers/services/routes-helper';
import { translate } from 'containers/services/translate';
import messages from 'containers/UploadDocuments/messages';
import { createStructuredSelector } from 'reselect';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { PAGES } from 'routes';
import { isEmpty, get } from 'lodash';
import upload from 'images/upload.svg';
import { uploadDocument } from 'containers/UploadDocuments/actions';
import { makeSelectDocument } from 'containers/UploadDocuments/selectors';
import { connect } from 'react-redux';
import Stepper from 'containers/AppContainer/Stepper';
import { makeSelecClaimToPreopen } from 'containers/PreOpeningPage/selectors';
import { DOCUMENT, EMPTY_DOCUMENT } from 'containers/data-structure';
import { setClaim } from 'containers/PreOpeningPage/actions';
import { DEFAULT_DOCUMENT_TYPE } from 'containers/UploadDocuments/constants';
import { openDocument } from 'containers/UploadDocuments/utils';
import { fileSelectHandler } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import {
  StyledDiv,
  Container,
  BootstrapInput,
  StyledDivUpload,
} from 'containers/UploadDocuments/styles';

export interface UploadDocumentsProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: { response: string } | {};
  storedClaimToPreopen: any;
  setClaim: Function;
  claimInfo: any;
}

const UploadDocuments: React.FC<UploadDocumentsProps> = (
  props,
): JSX.Element => {
  React.useEffect(() => {
    if (isEmpty(props.storedClaimToPreopen)) {
      pushTo(PAGES.LAWYER_HOME)();
    }
  });
  const [uploadedDocs, setUploadedDocs] = React.useState<any[]>([
    ...get(props.storedClaimToPreopen, 'documents', []),
  ]);
  const [documentType] = React.useState(DEFAULT_DOCUMENT_TYPE);

  const fileRef: React.RefObject<HTMLInputElement> = React.createRef();

  const uploadClick = () => {
    fileRef.current?.click();
  };

  useEffect(() => {
    const documents = [...uploadedDocs];
    const newDocument: any = {
      ...EMPTY_DOCUMENT,
      [DOCUMENT.IS_INDEXED]: false,
      [DOCUMENT.IS_VISIBLE]: true,
      [DOCUMENT.NAME]: `${translate(
        { ...messages.uploadedDocument },
        props,
      )} ${uploadedDocs.length + 1}`,
      [DOCUMENT.TYPE]: documentType,
      [DOCUMENT.URL]: get(props.uploadedDocument, 'response'),
    };

    const isPresent = uploadedDocs.filter(
      (doc: { url: string }) => doc.url === newDocument[DOCUMENT.URL],
    );

    if (isPresent.length === 0 && !isEmpty(props.uploadedDocument)) {
      documents.push(newDocument as never);
    }

    setUploadedDocs(documents);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.uploadedDocument]);

  const storeUploadDocument = () => {
    const storedClaim = { ...props.storedClaimToPreopen };
    storedClaim.documents = uploadedDocs;
    props.setClaim(storedClaim);
    !get(props, 'location.state.isFromSagis')
      ? pushTo(PAGES.RECAPITULATIF)()
      : pushTo(PAGES.RECAPITULATIF, {
          isFromSagis: true,
          procedureNatureId: get(props, 'location.state.procedureNatureId'),
          procedureType: get(props, 'location.state.procedureType'),
          judicialProcedureId: get(props, 'location.state.judicialProcedureId'),
        })();
  };

  const deleteDocument = (index: number) => () => {
    const documents = [...uploadedDocs];
    documents.splice(index, 1);
    setUploadedDocs(documents);
  };

  return (
    <div>
      <Stepper />
      <StyledDiv>
        {translate({ ...messages.UploadDocumentsTitle }, props)}
      </StyledDiv>
      <Container className="container">
        <StyledDivUpload>
          <span className="titleDoc">
            {translate(
              { ...messages.uploadDocumentsPageUploadDivTitle },
              props,
            )}
          </span>
          <div className="uploadInput">
            <Typography className="label">
              {translate(
                { ...messages.uploadDocumentsPageUploadDivSubTitle },
                props,
              )}
            </Typography>
            <ButtonGroup className="group" component="form">
              <Select
                className="input"
                value={documentType}
                input={<BootstrapInput />}
              >
                <MenuItem value="PV">{DEFAULT_DOCUMENT_TYPE}</MenuItem>
              </Select>
              <input
                id="selectImage"
                type="file"
                onChange={fileSelectHandler(props.uploadDocument, props)}
                ref={fileRef}
                hidden
              />

              <PrimaryButton
                className="button"
                variant="contained"
                disableElevation
                data-testid="upload-btn"
                onClick={uploadClick}
                title={translate({ ...messages.uploadDocumentBtn }, props)}
                lefticon={<img src={upload} alt="null" />}
              />
            </ButtonGroup>
          </div>
        </StyledDivUpload>
        <Card>
          <CardContent>
            <span className="title">
              {translate({ ...messages.UploadDocumentsSubTitle }, props)}
            </span>
            <div className="uploaded-docs-div">
              {uploadedDocs.map((document, index) => {
                return (
                  <div className="documentContainer" key={index}>
                    <div className="documentTypeContainer">
                      <span className="documentType">
                        {get(document, 'type')}
                      </span>
                      <div
                        className="iconStyle"
                        onClick={deleteDocument(index)}
                      >
                        <CloseIcon />
                      </div>
                    </div>
                    <span
                      className="documentTitle"
                      onClick={openDocument(document?.url)}
                    >
                      {get(document, 'name')}
                    </span>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      </Container>
      <NavigationButtons
        onPreviousClick={
          !get(props, 'location.state.isFromSagis')
            ? pushTo(PAGES.PREOPENING)
            : pushTo(PAGES.PREOPENING, {
                isFromSagis: true,
                procedureNatureId: get(
                  props,
                  'location.state.procedureNatureId',
                ),
                procedureType: get(props, 'location.state.procedureType'),
                judicialProcedureId: get(
                  props,
                  'location.state.judicialProcedureId',
                ),
              })
        }
        forwardClick={storeUploadDocument}
        disabledMoveButton={isEmpty(uploadedDocs)}
      />
    </div>
  );
};
const mapDispatchToProps = {
  uploadDocument,
  setClaim,
};
const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  storedClaimToPreopen: makeSelecClaimToPreopen(),
  claimInfo: makeSelectSearchClaims(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(UploadDocuments));
